
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-us",
      function () {
        return require("private-next-pages/terms-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms-us"])
      });
    }
  